module.exports = __webpack_public_path__ + "static/media/3lg.a317a911.jpg";